/**
 * Hook to detect bootstrap mode based on the current route path.
 * Used by employee-app to decide which API client to use
 * (admin bootstrap vs SSO-authenticated).
 */

import { useLocation } from 'react-router-dom';

export function useIsBootstrapMode() {
  const location = useLocation();
  return location.pathname.startsWith('/admin-setup/dashboard');
}
